import { ChemStructureApi } from './apis/impls/chem-structure-api';
export function chemStructureModule(bind) {
    bind(ChemStructureApi).to(ChemStructureApi);
}
